import useCurrentCompanyMetadata from "./current-company-metadata"

/**
 * Whether the company opted into the USA / Canada country breakout
 * (Settings → Company → Country Breakout). Gates the Regional view on the KPI
 * page; pipeline-dbt gates the regional models on the same
 * `metadata.regional.enabled` flag.
 */
export function useCountryBreakoutEnabled(): boolean {
  const metadata = useCurrentCompanyMetadata()
  return Boolean(metadata?.regional?.enabled)
}
